var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParcelAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C15.5589 2 18.5029 4.60923 18.9912 8.00297C19.0699 8.54972 18.6106 9 18.0534 9H17.386L15.1226 13.4869L16.1789 14.0415L12 16.2355L7.82111 14.0415L8.8774 13.4869L6.61397 9H5.94661C5.38941 9 4.93015 8.54972 5.00881 8.00297C5.49706 4.60923 8.44111 2 12 2ZM13.7849 12.7846L15.6941 9H8.30595L10.2151 12.7846L11.4556 12.1333C11.7942 11.9556 12.2058 11.9556 12.5444 12.1333L13.7849 12.7846Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0445 15.4049L12.8407 17.612V22L16.4679 20.0957C16.8238 19.9088 17.0445 19.5543 17.0445 19.1696V15.4049Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1593 17.612V22L7.5321 20.0957C7.17623 19.9088 6.95551 19.5543 6.95551 19.1696V15.4049L11.1593 17.612Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelAir);
export default __webpack_public_path__ + "static/media/parcel-air.7cf3b3381814e3394cbb514a56d4bad6.svg";
export { ForwardRef as ReactComponent };